// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2tfW_","buttons":"Footer_buttons__3lCcA"};